import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.784 15.878A9.6 9.6 0 0 0 21.599 12a9.6 9.6 0 1 0-19.2 0 9.6 9.6 0 0 0 9.6 9.6c1.707 0 3.31-.446 4.699-1.227L21.6 21.6z"
    />
  </svg>
);
export default SvgMessageCircle;
